// glonet-react-tailwind-project--src--components--GlonetAiLanding.js
// Selector for the glonet.ai landing (2026-08-11): the admin picks which page
// visitors see — the simplified v2 (default) or the frozen original.
//
//   wc_settings.landing_variant ('v2' | 'classic') — set in Admin → Go To
//   Market → Settings → "Landing page"; rides along on the public
//   /watercooler/activity response (same dodge as conversations_enabled:
//   the externally-managed API Gateway has no /public greedy proxy).
//
//   ?landing=classic / ?landing=v2 — URL override for previewing either
//   variant without flipping the global switch (never persisted).
//
// The last fetched value is cached in localStorage so returning visitors get
// the right page with no flash; first-ever visitors get v2 while the fetch
// resolves. Deleting the experiment later = delete GlonetAiLandingClassic.js,
// inline GlonetAiLandingV2 back into this file, drop the wc_settings key.
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../services/api";
import { API_PATHS } from "../config/apiConfig";
import GlonetAiLandingClassic from "./GlonetAiLandingClassic";
import GlonetAiLandingV2 from "./GlonetAiLandingV2";

const CACHE_KEY = "ga_landing_variant";
const normalize = (v) => (v === "classic" ? "classic" : "v2");

export default function GlonetAiLanding() {
  const location = useLocation();
  const override = new URLSearchParams(location.search).get("landing");
  const [variant, setVariant] = useState(() => {
    try { return normalize(localStorage.getItem(CACHE_KEY)); } catch (e) { return "v2"; }
  });

  useEffect(() => {
    api.get(API_PATHS.PUBLIC.WATERCOOLER_ACTIVITY)
      .then(({ data }) => {
        const v = normalize(data.landing_variant);
        setVariant(v);
        try { localStorage.setItem(CACHE_KEY, v); } catch (e) { /* storage off */ }
      })
      .catch(() => { /* keep the cached/default variant */ });
  }, []);

  const chosen = override ? normalize(override) : variant;
  return chosen === "classic" ? <GlonetAiLandingClassic /> : <GlonetAiLandingV2 />;
}
